import { getLocalizedString } from './get-localized-string.js';

const getDiscountDescriptions = (appliedDiscounts, locale)=>{
    // Business rule: filter out discount that require a discount code
    const filteredDiscounts = appliedDiscounts.filter((discount)=>!discount.requiresDiscountCode
    );
    return filteredDiscounts.map((discount)=>getLocalizedString(locale, discount.name)
    );
};

export { getDiscountDescriptions };
//# sourceMappingURL=get-discount-descriptions.js.map
